import { appEnv } from "./appEnv";

export const S3_URL = (() => {
  switch (appEnv) {
    case "production":
      return "https://assets.curon.co";
    default:
      return "https://assets.stg.curon.co";
  }
})();
